<script setup lang="ts">
    import { useVatStore } from '@/stores/vat';
    import { Checkbox } from '@/components/ui/form';

    const vatStore = useVatStore();
</script>

<template>
    <Checkbox
        id="sendToCustomer"
        v-model="vatStore.showPreviousSubmission"
        label="vat.show_previous_submission"
    />
</template>
